const market = {
  dsbz: "待上幣種",
  kpsj: "開盤倒計時/開盤時間",
  ykp: "已開盤",
  kpdjs: "開盤倒計時",
  worning: "非最終交易單價，僅供參考",
  swapTab_1: "USDT本位合約",
  swapTab_2: "幣本位合約",
  xinshou: "新手教程:",
  xinshousum: "註冊BiKing賬號，享受完美交易體驗",
  smcode: "加入官方QQ社群",
  // 新手教程
  zcdl: "註冊/登錄",
  kjmb: "買幣",
  zcyh: "立即註冊",
  smrz: "實名認證",
  c2ccz: "C2C充值",
  ksjy: "開始交易",
  otccz: "OTC充值",
  szjymm: "設定交易密碼",
  gdgjgl: "更多高級攻略",
  xsjc: "新手教程",
  xsjcd: "恭喜您注册成功，請立即設定交易密碼保證交易安全",
  ljzc: "註冊BiKing賬號，享受完美交易體驗",
  ctcz: "進行充提操作和交易之前，請先完成實名認證",
  rzcg: "恭喜您認證成功，請先購買一些數位貨幣體驗交易吧",
  tyjy: "立即體驗交易吧",
  // 登录
  welcome: "歡迎來到BiKing",
  totalAsset: "總資產估值",
  openOrder: "當前委託",
  dealStats: "成交統計",
  assetDeposit: "資產充提",
  fbtd: "法幣通道",
  yjhz: "一鍵劃轉",
  completeRealName: "請立即實名認證，通過後才能提現",
  firstTrading: "初次交易前，請先設定交易密碼",
  winVip: "會員限時5折搶購",
  login: "登入",
  forgotPassword: "忘記密碼",
  signUp: "新用戶註冊",
  QRcode: "掃碼登入",
  QR: "QR",
  passwordLogin: "密碼登入",
  codeExpired: "二維碼已失效",
  clickRefresh: "點擊重繪",
  QRsuccessfully: "掃碼成功",
  loginInApp: "請在APP內確認登入",
  backtoQR: "返回二維碼登入",
  scanInApp: "APP掃一掃安全登入",
  downloadApp: "下載最新APP",
  enterPhone: "請輸入正確的手機號",
  enterEmail: "請輸入正確的郵箱",
  emailOrPhone: "郵箱或手機號",
  email: "郵箱",
  phoneNum: "手機號",
  entersixCharacters: "請輸入至少6位密碼",
  password: "密碼",
  verification: "驗證碼不得少於4位",
  verificationCode: "驗證碼",
  phone: "手機",
  googleAuthentication: "穀歌身份驗證",
  boundPhone: "您已綁定手機",
  confirm: "確認",
  sendCode: "發送驗證碼",
  wrongCode: "驗證碼錯誤",
  noData: "暫無數據",
  phoneLogin: "手機登入",
  emailLogin: "郵箱登入",
  // 底部注册
  registerCoin: "注册BiKing帳號",
  openJourney: "開啟數位貨幣之旅",
  enterPhoneOrEmail: "請輸入您的郵箱或者手機號",
  registerNow: "立即注册",
  // 通知栏
  moreNew: "更多",
  gfgg: "官方公告",
  zxxw: "最新新聞",
  ckgd: "查看更多",
  // 榜单
  down: "跌幅榜",
  up: "漲幅榜",
  newCoins: "新幣榜",
  // 币种区
  searchCoin: "搜索想要的幣種",
  myMarket: "自選區",
  yxhy: "永续合約",
  wghy: "網格合約",
  mainBoard: "主流區",
  InnovationZone: "創新區",
  PotentialZone: "潜力區",
  LimitedZone: "低流通區",
  pair: "币對",
  hy: "合約",
  leverage: "最大槓桿",
  latestPrice: "最新價",
  changeHour: "涨跌幅",
  highHour: "24H最高",
  lowHour: "24H最低",
  priceTrend: "價格趨勢（3日）",
  volumeHour: "24H成交量",
  noSearch: "暫無搜索幣種",
  noAdd: "暫未添加自選",
  noYet: "暫未上架該幣種",
  noBi: "暫未上線幣種",
  risk: "風險提示",
  option: "期貨",
  cxjy: "創創新區幣種多在科技與市場等方面擁有一定成果，但其價格波動較大，風險也相對較高。建議您仔細查閱相關資料，在自身可承受範圍內决定是否參與",
  qljy: "潜力交易區尚處於市場發展初期，BiKing無法對其價值共識與市場流通情况做出任何保證。請您仔細瀏覽項目資訊，在自身能够承受的範圍內審慎參與投資。",
  qljyDao:
    "DAO交易區尚處於市場發展初期，BiKing無法對其價值共識與市場流通情況作出任何保證。請您仔細流覽專案資訊，在自身能夠承受的範圍內審慎參與投資。",
  default:
    "交易區尚處於市場發展初期，BiKing無法對其價值共識與市場流通情況作出任何保證。請您仔細瀏覽項目信息，在自身能夠承受的範圍內審慎參與投資。",
  storage:
    "存儲交易區尚處於市場發展初期，BiKing無法對其價值共識與市場流通情況作出任何保證。請您仔細流覽專案資訊，在自身能夠承受的範圍內審慎參與投資。",
  dlt: "低流通區數位資產市場流通性較低，存在著下架退市的風險。參與投資前建議謹慎考慮。",
  defi: "DEFI交易區尚處於市場發展初期，BiKing無法對其價值共識與市場流通情況作出任何保證。請您仔細流覽專案資訊，在自身能夠承受的範圍內審慎參與投資。",
  nft: "NFT交易區尚處於市場發展初期，BiKing無法對其價值共識與市場流通情況作出任何保證。請您仔細瀏覽項目信息，在自身能夠承受的範圍內審慎參與投資。",

  // 下载宣传
  bwyh: "百萬用戶的選擇，億萬價值的存在",
  qqcg: "超2000000用戶在BiKing開啟數位資產之旅",
  security: "安全保障",
  RSA1: "全方位多維度的系統化數位資產安全保障機制",
  // RSA2: "冷錢包+多重簽名等策略嚴格保護用戶資產安全",
  fastDeal: "極速交易",
  zzyf1: "自主研發微秒級高速撮合引擎，交易一觸即達",
  // zzyf2: "C2C交易商家24小時處理，加速C2C充提",
  tyzs: "體驗至上",
  zycp1: "便捷易用的交易服務，卓越團隊帶來極致體驗",
  // zycp2: "交易操作便捷，打造極致用戶體驗",
  CSR: "7*24客服",
  fwcxy1: "7*24小時全天候運營，第一時間為您解答諮詢",
  // fwcxy2: "以最優質的服務迎接每一位用戶的訪問",
  ssgz: "BiKing在手，交易我有",
  newApp: "BiKing新版App",
  zsjy: "掌上交易",
  lcty: "流暢體驗",
  realTime: "即時行情",
  kscb: "秒速充提",
  downloadby: "掃碼下載BiKing APP",
  // 顶部公告栏
  know: "我知道了",
  r: "日",
  s: "時",
  f: "分",
  m: "秒",
  qqg: "去搶購",
  jlblkq: "距離本輪開搶",
  jlbljs: "距離本輪結束",
  yrz: "預熱中",
  qgz: "搶購中",
  loginSuccess: "您已登錄成功，BiKing歡迎您！",
  fast: "閃電",
  buy: "購買",
  meBuy: "我要買",
  fastTip: "請輸入購買金額",
  price: "參考價",
  max: "最大下單金額為",
  yanzheng: "驗證",
  searchPlaceholder: "搜索您的國家或者國家區號",
  wan: "萬",
  qian: "千",
  yi: "億",
  addSelfCode: "添加自選",
  hz: "永續",
  yx: "研選",
  yjyzx: "研究院甄選項目",
  zx: "自選",
  bb: "現貨",
  hy: "合約",
  zfb: "漲幅榜",
  xbb: "新幣榜",
  bd: "幣對",
  zxj: "最新價",
  zdf24: "24H漲跌幅",
  high24: "24H最高",
  low24: "24H最低",
  turnover24: "24H成交量",
  zd24: "24h漲跌",
  zjrzd: "價格/日漲跌",
  scgl: "市場概覽",
  jysj: "交易資料",
  fyje: "返佣金額",
  推荐链接:'推薦連結',
  一键分享:'一鍵分享',
  不允许任何用户通过多:"不允許任何用戶透過多個帳號進行自我邀請行為，一經查實，所有的返傭將會被取消，被邀請帳號的手續費返傭也會被取消",
  交易人数: "交易人數",
  使用你的推荐链接:"使用你的推薦鏈接或推薦碼註冊的用戶才算你的被邀請人，如用戶註冊時未填寫推薦碼，則邀請關係不成立；",
  保留对活动的最终解释权:"如有任何疑問，請聯絡人工客服。 ",
  合约交易返佣: "獲得高達合約交易返傭",
  合约手续费: "合約手續費",
  合约返佣: "合約累计返傭",
  好友返佣比例: "好友返傭比例",
  我的返佣比例: "我的返傭比例",
  推荐人数: "推薦人數",
  推荐好友: "推薦好友",
  推荐总览: "推薦總覽",
  推荐: "推薦",
  推荐码: "推薦碼",
  推荐记录: "推薦記錄",
  是否交易: "是否交易",
  注册时间: "註冊時間（UTC+8）",
  用户邀请朋友无上限: "用戶邀請朋友無上限,被邀請人只有進行合約交易的手續費會計入返傭；",
  由于市场环境的改变:"由於市場環境的改變，欺詐風險的存在等原因，Biking保留隨時對返傭規則作出調整的最終解釋權。 ",
  被邀请人产生的真实交易手续费:"被邀請者產生的真實交易手續費，邀請人可獲得交易手續費對應比例的返傭，次日返至邀請人帳戶，具體入賬時間會在每日4點之後；",
  被邀请人只有进行合约: "被邀請人只有進行合約交易的手續費會計入返傭；",
  请输入账户UID: "請輸入帳戶UID",
  账户UID: "帳戶UID",
  返佣活动规则说明: "返傭活動規則說明：",
  返佣记录: "返傭記錄",
  ms: "是",
  mf: "否",
};

export { market };



// WEBPACK FOOTER //
// ./src/i18n/lang/market/tw.js